export const URL = 'https://ddluxuryapi-staging.diamondsdirect.com/v1';


// export const URL = 'https://dlapi.diamondsdirect.com/v1';
export const HEADERS = {
	'Accept': 'application/json',
	'Content-Type': 'application/json'
};
export const FILE_HEADERS = {
	'Accept': 'application/json'
};


// WEBPACK FOOTER //
// ./src/constants/api.prod